import couple from './couple';
export default couple;


// WEBPACK FOOTER //
// ./src/components/couple/index.js